module.exports = __webpack_public_path__ + "img/etiquetado3.f1bdfd68.jpg";